import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPostLaborAllocationRequestSchema,
  TPostLaborAllocationResponseSchema,
} from "../postLaborAllocation/postLaborAllocationSchema";

const URL = `reports/labor-allocation-xero`;
export const postLaborAllocationXero = (axios: IAxiosInstance) => {
  return async (requestBody: TPostLaborAllocationRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TPostLaborAllocationResponseSchema>
    >(URL, requestBody);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
